import { render } from "./new-receivable-account.vue?vue&type=template&id=e1d66b16"
import script from "./new-receivable-account.vue?vue&type=script&lang=js"
export * from "./new-receivable-account.vue?vue&type=script&lang=js"

import "./new-receivable-account.vue?vue&type=style&index=0&id=e1d66b16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__